export default {
    FETCH_FILTERS: "FETCH_FILTERS",
    FETCH_USER_DEFAULT_CONFIG:"FETCH_USER_DEFAULT_CONFIG",
    RESET_FILTERS: "RESET_FILTERS",
    FETCH_POI_FILTERS: "FETCH_POI_FILTERS",
    PUT_POI_FILTER_SESSION: "PUT_POI_FILTER_SESSION",
    FETCH_DRIVER_INSIGHTS_FILTERS: "FETCH_DRIVER_INSIGHTS_FILTERS",
    FETCH_VEHICLE_INSIGHTS_FILTERS: "FETCH_VEHICLE_INSIGHTS_FILTERS",
    FETCH_TRIP_ADMIN_FILTERS: 'FETCH_TRIP_ADMIN_FILTERS'
}